import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicEmptyCampaignTemplate({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 240 168"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M174.9 147.5c-42.86 4.43-60.36 17.5-100.9 15.93-47.85-1.86-89.92-36.47-66.05-74.93C26.15 59.16 62 64.5 93 40s63.31-27.7 85.5-14c40 28 90.89 111.73-3.6 121.5z"
        fill="#E9EDFB"
      />
      <path
        opacity={0.32}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M130.4 156.01c12.74-3.2 26.35-6.63 44.5-8.5 43.23-4.48 56.03-24.42 53.37-47.43-6.35-8.92-17.15-15.62-35.54-13.08-17.85 2.47-31.02 6.21-43.85 9.86C128.9 102.56 109.75 108 75 108c-32.55 0-53.97-11.06-66.37-20.57-.23.35-.46.7-.68 1.07-23.87 38.46 18.2 73.07 66.05 74.93 23.37.9 39.08-3.05 56.4-7.42z"
        fill="#8F9DD6"
      />
      <rect
        x={69}
        y={43}
        width={86}
        height={100}
        rx={3}
        fill="#F9FAFA"
        filter="url(#pic-empty-campaign-template_svg__a)"
      />
      <rect
        x={75}
        y={37}
        width={86}
        height={100}
        rx={4}
        fill="#fff"
        filter="url(#pic-empty-campaign-template_svg__b)"
      />
      <rect opacity={0.16} x={115} y={52} width={36} height={16} rx={1} fill="#9F9F9F" />
      <rect opacity={0.16} x={85} y={78} width={66} height={6} rx={1} fill="#9F9F9F" />
      <rect opacity={0.16} x={85} y={90} width={66} height={6} rx={1} fill="#9F9F9F" />
      <rect opacity={0.16} x={85} y={102} width={40} height={6} rx={1} fill="#9F9F9F" />
      <path
        d="M94.88 47.22a1 1 0 011.85 0l2.54 6.12a1 1 0 00.84.61l6.61.53a1 1 0 01.57 1.76l-5.03 4.3a1 1 0 00-.32 1l1.53 6.45a1 1 0 01-1.49 1.08l-5.66-3.45a1 1 0 00-1.04 0l-5.65 3.45a1 1 0 01-1.5-1.08l1.54-6.45a1 1 0 00-.32-1l-5.04-4.3a1 1 0 01.57-1.76l6.61-.53a1 1 0 00.84-.61l2.55-6.12z"
        fill="#FECE00"
      />
      <circle cx={175} cy={135} r={28} fill="#6478CB" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M180.11 126.82a9.1 9.1 0 015.24 8.22v.4h2.33v-.4c0-4.4-2.59-8.46-6.59-10.33l-.35-.16-.98 2.1.35.17zm-5.11 1.1a3.47 3.47 0 10-.01-6.93 3.47 3.47 0 000 6.94zm10.54 9.98a3.47 3.47 0 10.01 6.93 3.47 3.47 0 00-.01-6.93zm-20.94-2.86a9.1 9.1 0 015.24-8.22l.35-.17-.98-2.1-.35.16c-4 1.87-6.58 5.92-6.58 10.33v.4h2.32v-.4zm3.32 6.33a3.47 3.47 0 10-6.93 0 3.47 3.47 0 006.93 0zm12.86 3.25a9.09 9.09 0 01-11.57.04l-.3-.25-1.49 1.79.3.25a11.4 11.4 0 0014.54-.04l.3-.25-1.48-1.78-.3.24z"
        fill="#fff"
      />
      <defs>
        <filter
          id="pic-empty-campaign-template_svg__a"
          x={65}
          y={41}
          width={94}
          height={108}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2226_1546" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2226_1546" result="shape" />
        </filter>
        <filter
          id="pic-empty-campaign-template_svg__b"
          x={71}
          y={35}
          width={94}
          height={108}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={2} />
          <feColorMatrix values="0 0 0 0 0.2 0 0 0 0 0.207843 0 0 0 0 0.196078 0 0 0 0.08 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_2226_1546" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_2226_1546" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

SvgPicEmptyCampaignTemplate.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicEmptyCampaignTemplate.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicEmptyCampaignTemplate svgRef={ref} {...props} />
));
export default ForwardRef;
